module.exports = __webpack_public_path__ + "img/5.d99835f5.jpg";